var map = {
	"./afro.png": 2280,
	"./api.png": 5838,
	"./chat.png": 66,
	"./dama.png": 4715,
	"./githu.png": 4735,
	"./group.png": 2727,
	"./imessage.png": 5698,
	"./jori.png": 4246,
	"./joritech.png": 5030,
	"./kiambu.jpeg": 102,
	"./laptop.png": 4364,
	"./minalex.jpg": 5250,
	"./minalex.png": 6454,
	"./phonetwo.png": 5190,
	"./pushimg.svg": 6089,
	"./rocket.png": 4596,
	"./save.png": 3475,
	"./shortcode.png": 1039,
	"./smsman.png": 6881,
	"./target.png": 3232,
	"./ussd.png": 6289,
	"./woman.png": 9572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;